import { render, staticRenderFns } from "./OrthophotomapForm.vue?vue&type=template&id=4bcc2531&scoped=true&"
import script from "./OrthophotomapForm.vue?vue&type=script&lang=js&"
export * from "./OrthophotomapForm.vue?vue&type=script&lang=js&"
import style0 from "./OrthophotomapForm.vue?vue&type=style&index=0&id=4bcc2531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc2531",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VProgressLinear,VRow})
